import { UIHeading2, UIText2 } from '@cian/ui-kit';
import React from 'react';

import styles from './styles.css';

export interface ISuccessProps {
  withMortgage: boolean;
}

export const Success: React.FC<ISuccessProps> = ({ withMortgage }) => {
  return (
    <div className={styles['success-container']}>
      <UIHeading2>{withMortgage ? 'Спасибо!' : 'Контакты отправлены'}</UIHeading2>
      <UIText2>
        {withMortgage
          ? 'Мы сообщим вам, как только появится\nвыгодная ставка для вас'
          : 'Мы сообщим вам, как только ставки упадут'}
      </UIText2>
    </div>
  );
};
